'use es6';

export const MRUNAL = 'mgahnwat';
export const JEROME = 'jyang';
export const ALEX = 'aquatrano';